import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { Container, Section } from 'components';

import { ComfortAccountDetails } from './ComfortAccountDetails';
import { MainAccountDetails } from './MainAccountDetails';

export const AccountDetailsPage = () => {
  const { accountType } = useParams();

  const content =
    accountType === 'comfort' ? (
      <ComfortAccountDetails />
    ) : accountType === 'main' ? (
      <MainAccountDetails />
    ) : (
      <Navigate to="../.." replace relative="path" />
    );

  return (
    <Container>
      <Section>{content}</Section>
    </Container>
  );
};
